import { gql } from '@apollo/client'

export const DELETE_READ_NOTIFICATIONS_MUTATION = gql`
  mutation deleteReadNotifications {
    deleteReadNotifications {
      deletedCount
      errors
    }
  }
`
